import { render, staticRenderFns } from "./resister.vue?vue&type=template&id=27bf9907&"
import script from "./resister.vue?vue&type=script&lang=js&"
export * from "./resister.vue?vue&type=script&lang=js&"
import style0 from "./resister.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports